<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>
<div class="row">

  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">


    <mat-card>
      <mat-form-field style="width:80%">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search product">
      </mat-form-field>
      <mat-form-field style="width: 20%">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search product">
      </mat-form-field>

      <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" style="    height: 80%;
 overflow: auto;">

        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef style="width: 500px">Designation </th>
          <td mat-cell *matCellDef="let element"> {{element.designation}} </td>
        </ng-container>

        <ng-container matColumnDef="prixDzd">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Dinars </th>
          <td mat-cell *matCellDef="let element"> {{element.prixDzd| currency: ' '}} </td>
        </ng-container>
        <ng-container matColumnDef="prixEuro">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Euro </th>
          <td mat-cell *matCellDef="let element"> {{element.prixEuro| currency: ' '}} </td>
        </ng-container>

        <ng-container matColumnDef="prixDol">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Dollar </th>
          <td mat-cell *matCellDef="let element"> {{element.prixDol| currency: ' '}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let row">
            <button   mat-icon-button (click)="select(row)">
              <mat-icon>add_shopping_cart</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </mat-table>

    </mat-card>

  </div>

  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
    <mat-card *ngIf="selectedInvoice">



      <mat-slide-toggle *ngIf="!editFacturDetails"     [(ngModel)]="editFacturDetails">
        <span style="font-weight: bolder;; color: #05164D;">Editable</span>
      </mat-slide-toggle>
      <button mat-raised-button *ngIf="editFacturDetails" (click)="saveList()">Save List</button>

      <button mat-raised-button color="warn" *ngIf="editFacturDetails" (click)="cancelList()">Cancel </button>

      <h2 *ngIf="!editFacturDetails"><span *ngIf="selectedInvoice.tva">TTC: <span style="color: red;margin-right: 5px;">{{selectedInvoice.montantttc | currency: ' '}}</span></span> 
        <span *ngIf="!selectedInvoice.tva">HT: <span style="color: red;margin-right: 5px;">{{selectedInvoice.montantht | currency: ' '}}</span></span>{{selectedInvoice.devise | uppercase}}

        <button mat-raised-button style="background: #E0F2FD;" *ngIf="!editFacturDetails"
          (click)="ismail=true;sendFacture()">Send Proforma </button>

      </h2>







      <mat-table #table [dataSource]="dataSourceFactureDetails" class="mat-elevation-z8" style="    height: 80%;
        overflow: auto;">


        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef style="width: 60px;margin-right: 5px"> </th>
          <td mat-cell *matCellDef="let element">
            <button (click)="removeDetail(element)"   mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>




        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef style="width: 500px">Designation </th>
          <td mat-cell *matCellDef="let element">


            <span *ngIf="!editFacturDetails">{{element.designation}}</span>
            <p-button *ngIf="element.designation=='Package Sponsoring ' && editFacturDetails"
              (click)="importerDepuisSponsor(element)">Importer depuis package</p-button>
            <textarea id="pack{{element.idfacturedetail}}" matInput *ngIf="editFacturDetails" rows="2" [(ngModel)]="element.designation"></textarea>
          </td>
        </ng-container>

        <ng-container matColumnDef="prixunit">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Prix Unitaire </th>
          <td mat-cell *matCellDef="let element">
            <input matInput [(ngModel)]="element.prixunit" *ngIf="editFacturDetails">
            <span *ngIf="!editFacturDetails">{{element.prixunit| currency: ' '}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="quantite">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Quantité </th>
          <td mat-cell *matCellDef="let element">
            <input type="number" style="margin-left: 20px;width: 50px" matInput [(ngModel)]="element.quantite"
              *ngIf="editFacturDetails">

            <span *ngIf="!editFacturDetails">{{element.quantite}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="remise">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Remise </th>
          <td mat-cell *matCellDef="let element">
            <input matInput [(ngModel)]="element.remise" style="margin-left: 20px;width: 50px"
              *ngIf="editFacturDetails">

            <span *ngIf="!editFacturDetails">{{element.remise| currency: ' '}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="stotal">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">S.Total </th>
          <td mat-cell *matCellDef="let element">

            {{ element.prixunit *element.quantite - element.remise | currency: ' '}}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail "></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail;"></tr>
      </mat-table>


    </mat-card>

  </div>


</div>